const musicGenres = {
  hiphop: 'Hip-hop',
  edm: 'EDM',
  retro: 'Retro',
  rock: 'Rock',
  blues: 'Blues',
  jazz: 'Jazz',
  fank: 'Funk',
  mc: 'Mc',
  rAndB: 'R&B',
  chill: 'Chill',
};

export default musicGenres;
